import { Button } from "@design-system/Button/Button";
import { SettingsPanel } from "@design-system/SettingsPanel/SettingsPanel.lib";
import { ToggleGroup } from "@design-system/ToggleGroup/ToggleGroup";
import { AdjustmentsIcon } from "@icons";
import {
    activityChartDensitySchema,
    type ActivityChartDensity,
    DENSITY_LABELS,
} from "./activityChartDensity.lib";
import styles from "./ActivityChartDensityButton.module.scss";

interface ActivityChartDensityButtonProps {
    /** The picked or saved density, kept selected while the chart shows a coarser one; else the shown one. */
    density: ActivityChartDensity;
    /** Which density the chart shows instead, while it does. */
    hint?: string;
    onDensityChange: (density: ActivityChartDensity) => void;
}

/** The chart's view settings: what one bar covers. */
export function ActivityChartDensityButton({
    density,
    hint,
    onDensityChange,
}: ActivityChartDensityButtonProps) {
    return (
        <SettingsPanel.Root
            className={styles.panel}
            triggerTooltip="View settings"
            trigger={
                <Button
                    variant="primary"
                    size="md"
                    iconOnly
                    aria-label="View settings"
                >
                    <AdjustmentsIcon className="icon-color-gray-900" />
                </Button>
            }
        >
            <SettingsPanel.Section label="Chart density">
                <ToggleGroup.Root<ActivityChartDensity>
                    value={density}
                    onValueChange={(next) => next && onDensityChange(next)}
                    size="lg"
                    className={styles.toggle}
                    aria-label="Chart density"
                >
                    {activityChartDensitySchema.options.map((value) => (
                        <ToggleGroup.Item
                            key={value}
                            value={value}
                            className={styles.option}
                        >
                            {DENSITY_LABELS[value]}
                        </ToggleGroup.Item>
                    ))}
                </ToggleGroup.Root>
                <div role="status" className={styles.hint}>
                    {hint}
                </div>
            </SettingsPanel.Section>
        </SettingsPanel.Root>
    );
}
